export enum VideoAccessLevel {
    ParticipantsAndHost = 1,
    UploaderOnly        = 2,
    Everyone            = 3,
}

export interface GameVideoLink {
    id: string;
    gameID: string;
    userID: string;
    videoLink: string;
    accessLimitedTo: VideoAccessLevel;
    createdAt?: string;
    uploaderFullName: string;
    uploaderImage: string;
    uploaderUserID: string;
    canDelete: boolean;
}

export interface AddGameVideoLinkDTO {
    gameID: string;
    videoLink: string;
    accessLimitedTo: VideoAccessLevel;
}